import * as React from "react";
import styled, { css } from "styled-components";

export const RAIL_BUTTON_SIZE = 44;
export const RAIL_BUTTON_HEIGHT = 32;
export const RAIL_OFFSET = 12;
export const RAIL_GAP = 12;

const mobileLayout = css`
  top: auto;
  bottom: calc(100% + ${RAIL_OFFSET}px);
  right: ${RAIL_OFFSET}px;
  left: auto;
  flex-direction: row-reverse;
`;

const desktopLayout = css`
  top: ${RAIL_OFFSET}px;
  right: calc(-1 * (${RAIL_BUTTON_SIZE}px + ${RAIL_OFFSET}px));
  flex-direction: column;
`;

const Rail = styled.div<{ $isMobile?: boolean }>`
  position: absolute;
  display: flex;
  gap: ${RAIL_GAP}px;
  z-index: 1;
  ${(props) => (props.$isMobile ? mobileLayout : desktopLayout)}
`;

export interface TypeActionRailProps {
  children: React.ReactNode;
  /** When true, render horizontally above the parent (bottom-sheet mobile pattern). */
  isMobile?: boolean;
  /** Accessible group label for the rail. */
  "aria-label"?: string;
}

export const ActionRail: React.FC<TypeActionRailProps> = ({
  children,
  isMobile,
  "aria-label": ariaLabel = "Quick actions",
}) => {
  return (
    <Rail
      $isMobile={isMobile}
      data-slot="action-rail"
      data-qa-action-rail
      aria-label={ariaLabel}
      role="group"
    >
      {children}
    </Rail>
  );
};

ActionRail.displayName = "ActionRail";
